import { call } from '../../utils/serviceUtils';
import {
  DEPARTMENT_GET,
  DEPARTMENT
  } from '../../config/paths';

  
export function getDepartments() {
  return call.get(DEPARTMENT_GET,
    {

    });
}

export function deleteDepartmentById(id) {
  return call.delete(DEPARTMENT+'/'+id,
  {
    
  });
}

export function createDepartment(data) {
  return call.post(DEPARTMENT,data);
}

export function updateDepartment(id,data) {
  return call.put(DEPARTMENT+'/'+id,data);
}


